import React, { useState } from "react";
import { MoveHouseDetails } from "../MoveHouseDetails";
import DashboardInventoryList, {
  EditInventoryOnCallBack,
} from "../DashboardInventoryList";
import { AdditionalInformation } from "../AdditionalInformation";
import Immutable from "immutable";
import momentTimeZone from "moment-timezone";
import { AddressInfo, MoveItemsInfo } from "../estimate_details/MoveDetails";
// import { IND_CURRENCY_FORMAT_fn } from "../../common/currency_format";
import { StorageItems } from "../../inventory/StorageItems";
import { InvoiceList } from "../estimate_details/InvoiceList";
export default function EstimateCancelled(props) {
  const { data, cancelStatus, setListOfGoods } = props;
  const [showMoveDetails, setShowMoveDetails] = useState(false);
  // - callback 0 or 1 check for move type.
  const inventoryData = Immutable.fromJS(data.items);
  const clientTz = momentTimeZone.tz.guess();

  const cancelledDate = momentTimeZone.utc(data.date_of_ca).tz(clientTz);
  const showMoveDetailsFn = (params) => {
    setShowMoveDetails(!showMoveDetails);
  };
  let isBookedAndCancelled = false;
  const estimateAmount = data["estimateAmount"];
  if (cancelStatus === 9 || cancelStatus === 10) {
    isBookedAndCancelled = true;
  }

  const JSX = (
    <div className="move-container">
      <AddressInfo
        movingFrom={data.moving_from}
        movingTo={data.moving_to}
        fromAddress={data.from_address}
        toAddress={data.to_address}
        estimateId={data.estimate_id}
        estimateDetails={data}
      />
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 dashboard-item-common-spacing">
          <MoveItemsInfo
            propertySize={data.property_size}
            callback={data.call_back}
            totalItems={data.total_items}
            items={data.items}
            serviceType={data.service_type}
            inventoryData={inventoryData}
            distance={data.distance}
          />
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 dashboard-item-common-spacing">
          <div className="completed-date-container">
            <div className="completed-label">Cancelled On</div>
            <div className="font-size-md">
              {`${cancelledDate.format(
                "MMM Do YYYY"
              )} at ${cancelledDate.format("h:mm a")}`}
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 move-action-list dashboard-item-common-spacing">
          <div className="d-flex">
            <button
              onClick={showMoveDetailsFn}
              className="btn btn-sm w-100 light-btn"
            >
              View Move Details
            </button>
            <button className="btn btn-primary btn-sm ml-2 w-100">
              {data.custom_status}
            </button>
          </div>
        </div>
      </div>
      {isBookedAndCancelled === true && (
        <div className="row my-2">
          <div className="col-sm-12 col-md-12 col-lg-4 dashboard-item-common-spacing order-level-1">
            <div className="d-flex justify-content-between order-payment-details">
              <div>
                <div className="p-label">Total</div>
                <div className="p-data">{`₹ ${parseFloat(
                  estimateAmount["invoiceAmount"]
                )} /-`}</div>
              </div>
              <div>
                <div className="p-label">Paid</div>
                <div className="p-data">{`₹ ${estimateAmount["paid"]} /-`}</div>
              </div>
              <div>
                <div className="p-label">Refund</div>
                <div className="p-data">{`₹ ${estimateAmount["debit"]} /-`}</div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-4 order-level-2"></div>
          <div className="col-sm-12 col-md-12 col-lg-4 move-action-list dashboard-item-common-spacing order-level-3">
            <div className="d-flex flex-row">
              <div className="btn-sm w-100"></div>
              <InvoiceList
                balance={parseFloat(estimateAmount["balance"])}
                additionalAmount={parseFloat(
                  estimateAmount["additional_amount"]
                )}
                estimateData={data}
                estimateStatus={cancelStatus}
                setListOfGoods={setListOfGoods}
              />
            </div>
          </div>
        </div>
      )}

      {/* View Move Details */}
      {showMoveDetails === true && (
        <div className="row">
          <div className="col-12">
            <AdditionalInformation
              additionalInfo={data.old_house_additional_info}
            />
            <MoveHouseDetails moveData={data} />
            {data.call_back !== "1" && data.service_type === "relocation" && (
              <DashboardInventoryList inventoryItems={inventoryData} />
            )}
            {data.call_back === "1" && data.service_type === "relocation" && (
              <EditInventoryOnCallBack editDisabled={true} />
            )}
            {data.call_back === "1" && data.service_type === "storage" && (
            <StorageItems 
               items={data.storage_items}
               estimateId={data.estimate_id}
               editDisabled={true}
             />
            )}
          </div>
        </div>
      )}
      <hr />
    </div>
  );
  return JSX;
}
